export default "__VITE_ASSET__3a60d9d5__"